import { convert as urlSlug } from 'url-slug';

const usePackageUrl = () => {
  // megadott id, név és nyelv alapján generál egy url-t a borcsomagokhoz
  const createUrl = (winePackageId: number, packageName: string, languageCode: string) => {
    const domain = getPackageDomain(languageCode);

    const slug = urlSlug(packageName);

    return `/${domain}/${winePackageId}/${slug}`;
  };

  const getPackageDomain = (languageCode: string): string => {
    switch (languageCode) {
      case 'en':
        return 'winepackages';
      case 'de':
        return 'weinpaket';
      case 'pl':
        return 'pakiety-win';
      case 'hu':
      default:
        return 'borcsomagok';
    }
  };

  return { createUrl };
};

export default usePackageUrl;
